export default __webpack_public_path__ + "ffca6b96393d901ccb0f8f8165686297.svg";